import React        from 'react';
import Carousel     from './Carousel';
import About        from './About';
import Blog         from './Blog';
import OurTeam      from './OurTeam';
import ContactBlock from './ContactBlock';
import Overlay      from './Overlay';

export default function HomePage() {
    return (
        <section className="home-page">
            {/* <Overlay /> */}
            <Carousel />
            <About />
            {/*<Blog />*/}
            <OurTeam />
            <ContactBlock />
        </section>
    )
}
